import { arrayRemove, arrayUnion, doc, setDoc } from "firebase/firestore";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { auth, db } from "../firebase";
import { useEffect } from "react";
import Document from "./document";
import WhatsApp from "./whatsApp";
import Gala from "./gala";

export default function GalaUser({u, locations, groups}) {
    
    const [gala, setGala] = useState(false)

    function numberToPolishWeekday(num) {
        const days = {
          1: "Poniedziałek",
          2: "Wtorek",
          3: "Środa",
          4: "Czwartek",
          5: "Piątek",
          6: "Sobota",
          7: "Niedziela"
        };
        
        return days[num] || "Niepoprawny numer dnia (1–7)";
    }
      
    return (
        <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", gap: "5px", padding: "5px", minWidth: "90%", transition: "0.5s"})}>
            <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", gap: "10px", minWidth: "100%"})}>
                <div style={({display: 'flex', flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "0px", width: "100%"})}>
                    <h3 style={({fontSize: "13px", color: "rgb(30,30,30)"})}>{u?.user?.displayName} - {u?.acc?.parent?.phone}</h3>
                </div>
            </div>
        </div>
    )
}            

